<serviceos-ng-card
    *ngIf="communicationPreferences$ | async as communicationPreferences"
>
    <span class="title">{{ communicationPreferences.title }}</span>
    <div class="content">
        <p class="description" *ngIf="communicationPreferences.description">
            {{ communicationPreferences.description }}
        </p>
        <serviceos-web-preferences-form
            *ngIf="communicationPreferences.preferences"
        ></serviceos-web-preferences-form>
    </div>
</serviceos-ng-card>
